module.exports = __webpack_public_path__ + "media/images/logo_transparent-95a77a2e658c4544a6f451d2ec75a726.svg";